/* eslint-disable simple-import-sort/imports */
import { List } from "immutable";

import { createFromJS, immutableRecords } from "../../types";
import { InsetRecord } from "../../types/immutableRecords/helper/InsetRecord";
import { appStateActionTypes, appStateSelectors } from "../appState";
import combineReducersWithGlobal from "../combineReducersWithGlobal";
import { typeSelectors } from "../definition/types";
import { actionTypes } from "./actions";

//#!if readonly !== true
// import { undoRedoActionTypes } from "../undoRedo";
//#!endif

//#!if readonly !== true
// const replaceValue = (state = "", action) => {
// switch (action.type) {
// case actionTypes.CHANGE_REPLACE_VALUE:
// return action.value;
// default:
// return state;
// }
// };
// 
// const floatingNotification = (state = null, action, prevGlobalState) => {
// switch (action.type) {
// case actionTypes.ADD_NOTIFICATION: {
// const ignoredTypes = appStateSelectors.getIgnoredNotifications(prevGlobalState);
// const newFloatingNotification = createFromJS.UINotificationRecord(action.newItem);
// 
// return ignoredTypes.indexOf(action.newItem.type) === -1 ? newFloatingNotification : state;
// }
// case actionTypes.REMOVE_NOTIFICATION:
// return null;
// default:
// return state;
// }
// };
// 
// const pulsateIcon = (state = null, action, prevGlobalState) => {
// switch (action.type) {
// case actionTypes.PULSATE_ICON:
// return action.iconId;
// case actionTypes.PULSATE_ENTITY_ICON: {
// const t = typeSelectors.getOrderedPersonTypes(prevGlobalState).first();
// return t ? t.id : state;
// }
// default:
// return state;
// }
// };
//#!endif

const fileName = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_FILE_NAME:
      return action.name;
    default:
      return state;
  }
};

const settingsModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_SETTINGS_MODAL:
      return true;
    case actionTypes.HIDE_SETTINGS_MODAL:
      return false;
    //#!if readonly !== true
// case undoRedoActionTypes.CLEANUP:
// return false;
    //#!endif
    default:
      return state;
  }
};

const printPreviewModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_PRINT_PREVIEW_MODAL:
      return true;
    case actionTypes.HIDE_PRINT_PREVIEW_MODAL:
      return false;
    default:
      return state;
  }
};

const preferencesModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_PREFERENCES_MODAL:
      return true;
    case actionTypes.HIDE_PREFERENCES_MODAL:
      return false;
    default:
      return state;
  }
};

const syncSettingsModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_SYNC_SETTINGS_MODAL:
      return true;
    case actionTypes.HIDE_SYNC_SETTINGS_MODAL:
      return false;
    default:
      return state;
  }
};

const backupModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_BACKUP_MODAL:
      return true;
    case actionTypes.HIDE_BACKUP_MODAL:
      return false;
    default:
      return state;
  }
};

const aboutModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_ABOUT_MODAL:
      return true;
    case actionTypes.HIDE_ABOUT_MODAL:
      return false;
    default:
      return state;
  }
};

const exportImagePreviewModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_EXPORT_IMAGE_PREVIEW_MODAL:
      return true;
    case actionTypes.HIDE_EXPORT_IMAGE_PREVIEW_MODAL:
      return false;
    default:
      return state;
  }
};

const exportTsfModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_EXPORT_TSF_MODAL:
      return true;
    case actionTypes.HIDE_EXPORT_TSF_MODAL:
      return false;
    default:
      return state;
  }
};

const exportCsvModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_EXPORT_CSV_MODAL:
      return true;
    case actionTypes.HIDE_EXPORT_CSV_MODAL:
      return false;
    default:
      return state;
  }
};

const importCsvModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_IMPORT_CSV_MODAL:
      return true;
    case actionTypes.HIDE_IMPORT_CSV_MODAL:
      return false;
    default:
      return state;
  }
};

const saveTemplateModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_SAVE_TEMPLATE_MODAL:
      return true;
    case actionTypes.HIDE_SAVE_TEMPLATE_MODAL:
      return false;
    default:
      return state;
  }
};

const inspectorModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_INSPECTOR_MODAL:
      return true;
    case actionTypes.HIDE_INSPECTOR_MODAL:
      return false;
    //#!if iOS === true && readonly === true
    // Open the inspector modal when selecting item in iOS readonly modes
// case appStateActionTypes.ADD_ITEMS_TO_SELECTION:
// return true;
// case appStateActionTypes.SELECT_ITEMS:
// return action.ids.length > 0 ? true : state;
    //#!endif
    default:
      return state;
  }
};

const sampleModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_SAMPLE_MODAL:
      return true;
    case actionTypes.HIDE_SAMPLE_MODAL:
      return false;
    default:
      return state;
  }
};

const fileVersionTooLowModalOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_OPEN_FILE_MODAL:
      return true;
    case actionTypes.HIDE_OPEN_FILE_MODAL:
      return false;
    default:
      return state;
  }
};

const openFileAllowReadonly = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SHOW_OPEN_FILE_MODAL:
      return Boolean(action.allowReadonly);
    default:
      return state;
  }
};

const savedFiltersExpanded = (state = false, action) => {
  switch (action.type) {
    case actionTypes.COLLAPSE_SAVED_FILTERS:
      return false;
    case actionTypes.EXPAND_SAVED_FILTERS:
      return true;
    default:
      return state;
  }
};

const searchReplaceExpanded = (state = false, action) => {
  switch (action.type) {
    case actionTypes.EXPAND_SEARCH_REPLACE:
      return true;
    case actionTypes.COLLAPSE_SEARCH_REPLACE:
      return false;
    default:
      return state;
  }
};

const searchCaseSensitive = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SEARCH_CASE_SENSITIVE:
      return action.caseSensitive;
    default:
      return state;
  }
};

const searchWholeWord = (state = false, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SEARCH_WHOLE_WORD:
      return action.wholeWord;
    default:
      return state;
  }
};

const searchValue = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SEARCH_VALUE:
      return action.value;
    default:
      return state;
  }
};

const excludeSearchFields = (state = List(), action) => {
  switch (action.type) {
    case actionTypes.CHANGE_SEARCH_IN_FIELD:
      return action.value ? state.filter(f => f !== action.field) : state.push(action.field);
    default:
      return state;
  }
};

const menuPopoverType = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_MENU_POPOVER_TYPE:
      return action.typeId;
    default:
      return state;
  }
};

const showGlobalFilterPanel = (state = null, action) => {
  switch (action.type) {
    case actionTypes.OPEN_LOCAL_FILTER_PANEL:
    case actionTypes.TOGGLE_LOCAL_FILTER_PANEL:
      return false;
    case actionTypes.TOGGLE_GLOBAL_FILTER_PANEL:
      return true;
    default:
      return state;
  }
};

const deviceInsets = (state = InsetRecord(), action) => {
  switch (action.type) {
    case actionTypes.SET_DEVICE_INSETS:
      return immutableRecords.InsetRecord(action.insets);
    default:
      return state;
  }
};

const isEditMode = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ENTER_EDIT_MODE:
      return true;
    case actionTypes.EXIT_EDIT_MODE:
      return false;
    case actionTypes.ENTER_ENTITY_EDIT_MODE:
      return false;
    default:
      return state;
  }
};

const isEntityEditMode = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ENTER_ENTITY_EDIT_MODE:
      return true;
    case actionTypes.EXIT_ENTITY_EDIT_MODE:
      return false;
    case actionTypes.ENTER_EDIT_MODE:
    case appStateActionTypes.SET_LEFT_PANEL_MODE:
    case appStateActionTypes.HIDE_LEFT_PANEL:
    case appStateActionTypes.TOGGLE_ENTITY_LIST:
    case appStateActionTypes.OPEN_ENTITY_LIST:
    case appStateActionTypes.TOGGLE_SEARCH_PANEL:
    case appStateActionTypes.OPEN_SEARCH_PANEL:
    case appStateActionTypes.TOGGLE_FILTER_PANEL:
    case appStateActionTypes.TOGGLE_GLOBAL_FILTER_PANEL:
    case appStateActionTypes.TOGGLE_LOCAL_FILTER_PANEL:
    case appStateActionTypes.OPEN_LOCAL_FILTER_PANEL:
    case appStateActionTypes.TOGGLE_SETTINGS_PANEL:
    case appStateActionTypes.TOGGLE_SCROLL_TO_DATE_PANEL:
      return false;
    default:
      return state;
  }
};

const leftPanelHasChildPopover = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SET_LEFT_PANEL_HAS_CHILD_POPOVER:
      return action.value;
    default:
      return state;
  }
};

const syncInProgress = (state = false, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SYNC_PROGRESS:
      return action.syncInProgress;
    default:
      return state;
  }
};

const syncProgressLabel = (state = null, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SYNC_PROGRESS:
      return action.syncProgressLabel;
    default:
      return state;
  }
};

const syncProgressPercent = (state = 0, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SYNC_PROGRESS:
      return action.syncProgressPercent;
    default:
      return state;
  }
};

export default combineReducersWithGlobal(createFromJS.UIStateRecord({}), {
  //#!if readonly !== true
// replaceValue,
// floatingNotification,
// pulsateIcon,
// leftPanelHasChildPopover,
  //#!endif
  fileName,
  settingsModalOpen,
  printPreviewModalOpen,
  preferencesModalOpen,
  syncSettingsModalOpen,
  backupModalOpen,
  aboutModalOpen,
  exportImagePreviewModalOpen,
  exportTsfModalOpen,
  exportCsvModalOpen,
  importCsvModalOpen,
  inspectorModalOpen,
  fileVersionTooLowModalOpen,
  openFileAllowReadonly,
  sampleModalOpen,
  saveTemplateModalOpen,
  savedFiltersExpanded,
  searchReplaceExpanded,
  searchCaseSensitive,
  searchWholeWord,
  searchValue,
  excludeSearchFields,
  menuPopoverType,
  showGlobalFilterPanel,
  deviceInsets,
  isEditMode,
  isEntityEditMode,
  syncInProgress,
  syncProgressLabel,
  syncProgressPercent
});
